import { useMemo } from 'react';
import { flow } from 'fp-ts/lib/function';
import { CompleteQuery } from 'modules/queryBuilder/types';
import { useConvertToSubscribedMessageCondition } from './useConvertToSubscribedMessageCondition';

export const useUpdatedListDetailsSearchQuery = (
  query?: CompleteQuery,
): CompleteQuery | undefined => {
  const convertToSubscribedMessageCondition = useConvertToSubscribedMessageCondition();

  return useMemo(
    () =>
      query
        ? {
            ...query,
            searchQueries: query.searchQueries.map((criteria) => ({
              ...criteria,
              searchQueries: criteria.searchQueries.map((requirement) => ({
                ...requirement,
                searchCombo: {
                  ...requirement.searchCombo,
                  searchQueries: requirement.searchCombo.searchQueries.map(
                    flow(convertToSubscribedMessageCondition),
                  ),
                },
              })),
            })),
          }
        : undefined,
    [query],
  );
};
